import "@fortawesome/fontawesome-free/js/all";
import '../styles'
import '../static'

const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

import "controllers"